import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: `calc(100% - ${theme.spacing(1.25)}px)`,
      minWidth: 'fit-content',
      display: 'flex',
      alignItems: 'baseline',
      padding: `${theme.spacing(1)}px 0`,
      margin: theme.spacing(1),
      backgroundColor: '#F7F7F7',
      borderRadius: theme.shape.borderRadius * 2.4,
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
      userSelect: 'none',
      border: '2px solid transparent',

      transition: theme.transitions.create('border-color', {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),

      '&.similar-schools': {
        padding: `${theme.spacing(1.5)}px 0`,
      },

      '&.selected': {
        borderColor: theme.palette.primary.main,
      },

      '&.selectable': {
        cursor: 'pointer',
      },
    },
    grid: {
      display: 'grid',
      width: '100%',
    },
    cellWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      overflow: 'hidden',
      width: '100%',
      maxWidth: '100%',
      flex: 1,
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(1),

      '&.similar-schools': {
        overflow: 'unset',
      },

      '&.render-component': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    defaultRenderWrapper: {
      display: 'flex',
      width: '100%',
      maxWidth: '100%',
      flexDirection: 'column',
    },
    defaultRender: {
      paddingTop: theme.spacing(1.5),
      width: '100%',
      maxWidth: '100%',

      '&.similar-schools': {
        paddingTop: theme.spacing(0.75),
      },
    },
    separator: {
      borderLeft: `1px solid ${theme.palette.grey[200]}`,
    },
    expandButton: {
      minWidth: 'fit-content',
      color: theme.palette.text.secondary,
    },
    expandIcon: {
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.standard,
        easing: theme.transitions.easing.easeInOut,
      }),

      '&.expanded': {
        transform: 'rotate(180deg)',
      },
    },
    expansibleContainer: {
      paddingRight: theme.spacing(1.5),
      display: 'flex',
      alignItems: 'start',
      justifyContent: 'flex-end',
      paddingTop: theme.spacing(0.5),
    },
    collapse: {
      width: '100%',
    },
    similarSchoolsTitle: {
      color: theme.palette.grey[500],
      paddingTop: theme.spacing(1),
    },
  }),
);
